/**
 * Which resend action to show for a (non-deactivated) vendor row.
 * - 'invite': status is 'invited', or the vendor was never invited (no
 *   invited_at) — they still need the set-password magic link.
 * - 'login_link': the vendor has been invited and moved on; send a short-lived
 *   magic login link, with no status/snapshot change.
 */
export function resendActionForStatus(
  status: string,
  invitedAt: string | null,
): 'invite' | 'login_link' {
  if (!invitedAt || status === 'invited') return 'invite';
  return 'login_link';
}
